export default class WebsocketWrapper {
	Socket;

	BaseUrl;

	Connected;

	Consumers = [];

	Queue = [];

	ConnectionAttemps = 0;

	ReconnectToken;

	SessionId;

	constructor(consumer, sessionId, baseUrl) {
		this.SessionId = sessionId;

		const www = document.location.hostname;
		if (!baseUrl) {
			if (www.indexOf('oferteo-dev.pl') > -1) {
				baseUrl = 'wss://wss.oferteo-dev.pl';
			}
			if (www.indexOf('oferteo-fix.pl') > -1) {
				baseUrl = 'wss://wss.oferteo-fix.pl';
			}
			if (www.indexOf('oferteo-tst.pl') > -1) {
				baseUrl = 'wss://wss.oferteo-tst.pl';
			}
			if (www.indexOf('oferteo-pre.pl') > -1) {
				baseUrl = 'wss://wss.oferteo-pre.pl';
			}
			if (www.indexOf('oferteo.pl') > -1) {
				baseUrl = 'wss://wss.oferteo.pl';
			}
		}
		this.BaseUrl = baseUrl;

		if (consumer && 'OnSocketMessage' in consumer) {
			this.Consumers.push(consumer);
			this.CreateSocket();
		} else {
			this.OnError('No consumer specified.');
		}
	}

	CreateSocket() {
		if (this.ConnectionAttemps > 30) {
			this.OnError('CreateSocket: Hit limit.');
			return;
		}
		try {
			this.ConnectionAttemps++;

			let connectUrl = `${this.BaseUrl}?sessionId=${this.SessionId}`;
			if (this.ReconnectToken) {
				connectUrl += `&token=${this.ReconnectToken}`;
			}
			this.Socket = new WebSocket(connectUrl);

			this.Socket.addEventListener('open', (e) => this.OnOpen(e));
			this.Socket.addEventListener('message', (e) => this.OnMessage(e));
			this.Socket.addEventListener('close', (e) => this.OnClose(e));
			this.Socket.addEventListener('error', () => this.OnError(''));
			window.setInterval(() => {
				this.Send({
					type: 'Heartbeat',
				});
			}, 60000);
		} catch (err) {
			this.OnError(err);
		}
	}

	OnOpen() {
		this.Socket.send(JSON.stringify({
			type: 'Hello',
			data: {
				sessionId: this.SessionId,
			},
		}));
	}

	OnError() {}

	OnMessage(e) {
		if (!e.data || this.ConnectionAttemps > 30) {
			this.OnError('OnMessage: No data or hit limit.');
			return;
		}
		const m = JSON.parse(e.data);
		if (m.type === 'Hello') {
			this.Init(m);
		}
		this.Consumers.forEach((c) => c.OnSocketMessage(m));
	}

	OnClose() {
		this.Connected = false;
		window.setTimeout(() => {
			this.CreateSocket();
		}, 30000);
	}

	Init(m) {
		this.Connected = m.data.status === 'SUCCESS';
		if (m.data.token && (!this.ReconnectToken || m.data.token !== this.ReconnectToken)) {
			this.ReconnectToken = m.data.token;
		}
		if (this.Connected) {
			for (const queuedMessage of this.Queue) {
				this.Send(queuedMessage);
			}
			this.Queue = [];
		}
	}

	Send(m) {
		if (this.ConnectionAttemps > 30) {
			this.OnError('Send: Hit limit.');
			return;
		}
		if (this.Connected) {
			this.Socket.send(JSON.stringify(m));
		} else {
			this.Queue.push(m);
		}
	}
}
